import { Box, Icon, Link } from "@bca/ui-library";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";

import { IVehicleDetailsModule } from "../common/analytics/analytics.types";
import analytics from "../common/analytics/analytics";
import { IProductPushable } from "../common/analytics/analytics.types";
import { PrintProps } from "./PrintProps.type";
import ListRegularSVG from "../icons/ListRegularSVG";
import { StoreType } from "../StoreType";
import { handlePrintExportFile } from "../utils/handlePrintExportFile";
import { GET_STATE } from "../redux/slices/appSlice";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

const StyledBox = styled(Box)`
  list-style-type: none;
`;

const StyledLi = styled.li<{ children: React.ReactNode }>`
  display: flex;
  flex-direction: row;
`;

const pushPrintAnalytics = (
  vehicleAnalytics: IVehicleDetailsModule,
  label: "sale-section" | "full-day"
) => {
  analytics.push<IProductPushable>({
    event: {
      name: "click",
      category: "button",
      label: label,
      action: "print",
      type: "pdf",
      section: "card",
    },
    product: {
      vehicle: [vehicleAnalytics],
    },
  });
};

const PopoverContent: React.FunctionComponent<PrintProps> = ({
  printUrls,
  vehicleAnalytics,
  pdfEnabled,
}) => {
  const dispatch = useDispatch();
  const {
    app: { isLoadingFile, isToUseAuthZero },
  }: StoreType = useSelector(GET_STATE);
  const { accessToken } = useAuth(!isToUseAuthZero);

  return (
    <StyledBox
      as="ul"
      p="0"
      my="0"
      display="grid"
      css={`
        gap: 14px;
      `}
    >
      {printUrls.map((li) => (
        <StyledLi key={li.name}>
          {li.name.toLocaleLowerCase().includes("section") && (
            <ListRegularSVG
              width="18px"
              height="18px"
              fill="primary-light-blue"
              mr={3}
            />
          )}
          {li.name.toLocaleLowerCase().includes("day") && (
            <Icon
              name="gavel"
              weight="regular"
              width="18px"
              height="18px"
              color="primary-light-blue"
              mr="12px"
            ></Icon>
          )}
          <Link
            color="primary-light-blue"
            underline="always"
            css={`
              font-size: 14px;
              :focus {
                outline: none;
              }
              ${isLoadingFile &&
              `
              opacity: 0.3;
              cursor: default;
            `}
            `}
            onClick={(event) => {
              event.stopPropagation();
              pdfEnabled &&
                handlePrintExportFile(
                  dispatch,
                  li.url,
                  "printSelectedVehicles",
                  accessToken,
                  isToUseAuthZero
                );
              pushPrintAnalytics(
                vehicleAnalytics,
                li.name.toLocaleLowerCase().includes("section")
                  ? "sale-section"
                  : "full-day"
              );
            }}
            href={!pdfEnabled ? li.url : null}
            target="_blank"
          >
            {li.name}
          </Link>
        </StyledLi>
      ))}
    </StyledBox>
  );
};

export default PopoverContent;
